var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isSinglePoint)?_c('packet-single-point',{attrs:{"packet":_vm.packet.packet,"peerGroups":_vm.packet.peerGroups}}):_c('packet-multi-point',{attrs:{"packet":_vm.packet.packet,"peerGroups":_vm.packet.peerGroups}})}
var staticRenderFns = []

export { render, staticRenderFns }